<template>
  <div class="order_block recipient-block">
    <h3 class="title">Данные получателя</h3>

    <div class="content">
      <div class="fields">
        <standart-filed
            id="name" title="Имя получателя" type="text" placeholder="Введите имя"
            :value="recipientData.fio" @updated="recipient_fio_change($event)"
            :error-text="recipientData.fio_error"
        >
        </standart-filed>

        <standart-filed
            id="phone" title="Телефон получателя" type="text" placeholder="+7 (900) 000-00-00"
            :value="recipientData.phone" @updated="recipient_phone_change($event)"
            :error-text="recipientData.phone_error"
            mask="+7 (###) ###-##-##"
        >
        </standart-filed>
      </div>
    </div>
  </div>
</template>

<script>

import StandartFiled from "@/components/share/StandartField";
export default {
  name: 'RecipientBlock',
  props: {
    recipientData : Object
  },
  components: {
    StandartFiled
  },
  data() {
    return{

    }
  },
  mounted() {

  },
  methods : {
    recipient_fio_change : function(value) {
      this.$emit("recipient_fio_change", value);
    },
    recipient_phone_change : function(value) {
      this.$emit("recipient_phone_change", value);
    }
  }
}
</script>

<style scoped>

.recipient-block {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.recipient-block .fields{
  display: flex;
  gap: 16px;
}

/*MOBILE*/
@media (max-width: 1250px)
{
  .recipient-block {
    gap: 18px;
  }

  .recipient-block .fields{
    display: flex;
    flex-direction: column;
    gap: 14px;
  }
}
</style>



<style>

</style>
